//@flow

// Vendors
import React from 'react';
import { useDispatch } from 'react-redux';

// Components
import { Modal } from '../../../../../modals';
import Trans from '../../../../../Trans/Trans';

// Actions
import { closeModal } from '../../../../../../../reducers/modal/modalActions';

// Styles
import '../file-upload-modal.scss';
import {TxButton, TxButtonMode} from "texkit-ui";


const TooManyFilesModal = () => {
  const dispatch = useDispatch();
  return (
    <Modal name="TooManyFilesModal" className="file-upload-modal">
      <h2 className="h1 modal-title-general">
        <Trans file="dps" id="dps_SurrenderDLForID_Too_Many_files" />
      </h2>
      <p className="modal-description-general">
        <Trans file="dps" id="dps_SurrenderDLForID_Too_Many_files_Subheading" />
      </p>

      <TxButton
        className="modal-close-button-general"
        mode={TxButtonMode.Primary}
        type="submit"
        onClick={() =>
          dispatch(closeModal('TooManyFilesModal'))
        }
      >
        <Trans file="Labels" id="gotIt" fallback="OK, got it" />
      </TxButton>
    </Modal>
  );
};

export default TooManyFilesModal;
